import * as React from "react";
import Svg, { G, Defs, SvgProps, Rect } from "react-native-svg";

function SuccessIcon(props: SvgProps) {
  return (
    <Svg width={60} height={60} viewBox="0 0 60 60" fill="none" {...props}>
      <G clipPath="url(#clip0_368_9286)">
        <path
          d="M30 5.67091C36.4484 5.68329 42.6288 8.25083 47.1885 12.8106C51.7482 17.3703 54.3157 23.5506 54.3281 29.999L54.3242 30.4502C54.2379 35.1041 52.8179 39.6392 50.2285 43.5147C47.5553 47.5154 43.755 50.6343 39.3096 52.4756C34.8643 54.3168 29.9729 54.7981 25.2539 53.8594C20.5347 52.9207 16.2002 50.6035 12.7979 47.2012C9.39551 43.7988 7.07835 39.4643 6.13965 34.7451C5.20098 30.0261 5.68226 25.1347 7.52344 20.6895C9.36477 16.2441 12.4836 12.4437 16.4844 9.77052C20.3599 7.18111 24.895 5.76111 29.5488 5.67481L30 5.67091ZM40.3467 22.5078C39.8514 22.4845 39.3658 22.6535 38.9922 22.9795L38.9912 22.9805L26.5547 34.832L21.0088 29.543H21.0078C20.8278 29.358 20.613 29.2102 20.375 29.1104C20.1361 29.0101 19.8791 28.9595 19.6201 28.9609C19.3611 28.9624 19.1048 29.0162 18.8672 29.1191C18.6295 29.2222 18.4146 29.3725 18.2363 29.5606C18.0581 29.7485 17.9193 29.971 17.8291 30.2139C17.739 30.4565 17.6987 30.7151 17.7109 30.9736C17.7232 31.2324 17.7876 31.4865 17.9004 31.7197C18.0131 31.9529 18.1721 32.1608 18.3672 32.3311L25.2334 38.8926C25.4078 39.0634 25.6142 39.1984 25.8408 39.2891C26.0676 39.3798 26.3105 39.4233 26.5547 39.4199C26.9917 39.4226 27.4151 39.2792 27.7578 39.0137L27.8994 38.8926L41.6338 25.7676L41.6348 25.7656C41.9802 25.4098 42.1749 24.9344 42.1777 24.4385C42.1806 23.9427 41.9915 23.4653 41.6504 23.1055C41.3092 22.7456 40.842 22.5313 40.3467 22.5078Z"
          fill="#0E7A41"
          stroke="#0E7A41"
          strokeWidth="0.0937661"
        />
      </G>
      <Defs>
        <clipPath id="clip0_368_9286">
          <Rect width="60" height="60" fill="white" />
        </clipPath>
      </Defs>
    </Svg>
  );
}

export default SuccessIcon;
